var render = function render(){var _vm=this,_c=_vm._self._c;return _c('apexchart',_vm._b({},'apexchart',_vm.config,false))
}
var staticRenderFns = []

export { render, staticRenderFns }